import React from 'react';
import { LuEllipsisVertical, LuSquare, LuSquareCheck } from 'react-icons/lu';
import { M } from '../servicio/ServicioUI';
import { estiloEtiqueta, ALERTA } from '../../utils/estados';
import AvatarTecnico from '../ui/AvatarTecnico';

const primerNombre = (n) => (n || '').trim().split(' ')[0] || '';
// Tablet / compu chica (18-oct-2026): sin la columna Técnico (va abajo del cliente), porque con las 7
// columnas fijas el cliente se quedaba sin ancho y los títulos se pisaban ("CLIEÉNICO").
// 23-oct-2026 (testeo U2): en compu la app va con zoom 1,2, así que las columnas fijas ocupaban 20 % más
// y al cliente le quedaban ~80 px ("Depósito …"). Ahora la columna Técnico aparte recién desde 2xl, y
// angosta: hasta ahí el técnico va abajo del cliente, que es lo que más se lee.
const GRID = 'md:grid-cols-[104px_minmax(0,1fr)_100px_110px_132px_32px] 2xl:grid-cols-[120px_minmax(0,1fr)_120px_110px_110px_150px_32px]';
export const GRID_GAP = 'gap-3';

export const ENCABEZADO_GRID = GRID;

// Una fila de la lista de Trabajos. El botón del próximo paso toma el color de la
// etapa (mismo color que el puntito), así cada paso se distingue a simple vista.
// Celular (3-oct-2026): tarjeta compacta en 3 líneas + botón, para no scrollear tanto.
export default function TrabajoFila({ f, etapa, boton, textoSeguimiento, onAbrir, onMenu, seleccionando, seleccionado, onToggle }) {
    const tecTxt = f.tecnicoTexto || (f.tecnico ? primerNombre(f.tecnico) : f.esVenta ? 'Venta · sin técnico' : 'Sin técnico');
    // Opción 1 de color: el borde y la etiqueta dicen la etapa; lo atrasado, en rojo.
    const borde = f.alerta ? ALERTA.color : etapa.color;
    const etiqueta = (
        <span className="px-1.5 py-[1px] rounded-md text-[11px] font-black uppercase tracking-wide shrink-0" style={estiloEtiqueta(etapa)}>{etapa.label}</span>
    );
    // Botón del próximo paso: color de la familia (el gris de "Por hacer" va en tinta),
    // rojo si está atrasado.
    const estiloBoton = f.alerta ? { background: ALERTA.color, color: '#fff' }
        : etapa.familia === 'hacer' || !etapa.familia ? null
        : { background: etapa.color, color: etapa.sobre };
    // Pedido de empresa sin agendar: todavía no tiene monto (20-oct-2026)
    const monto = f.sinMonto ? null : f.monto == null ? <span className="text-muted font-bold text-caption">A fin de mes</span>
        : f.monto > 0 ? <M valor={f.monto} className="font-black" /> : <span className="text-muted">—</span>;
    const casilla = seleccionando && (
        <button type="button" onClick={onToggle} aria-label="Seleccionar" className="text-ink shrink-0">
            {seleccionado ? <LuSquareCheck size={18} /> : <LuSquare size={18} />}
        </button>
    );
    const accion = f.accion === 'seguimiento' ? (
        <span className="text-caption text-muted md:text-right">{textoSeguimiento(f)}</span>
    ) : boton && !seleccionando && (
        <button type="button" onClick={() => boton.run(f)}
            className={`h-9 md:h-10 px-4 rounded-xl text-label font-black active:scale-95 transition-all shrink-0 ${boton.primaria ? (estiloBoton ? '' : 'bg-ink text-page') : 'bg-chip text-ink border border-black/10 dark:border-white/10'}`}
            style={boton.primaria ? estiloBoton || undefined : undefined}>
            {f.botonLabel || boton.label}
        </button>
    );
    // Celular: sin "Ver" (es tocar la tarjeta); con tarifa mensual, una palabra en vez de "A fin de mes"
    const accionCel = f.accion === 'seguimiento' || boton?.label === 'Ver' ? null : accion;
    const montoCel = f.sinMonto ? null : f.monto == null ? <span className="text-muted font-bold text-caption">Mensual</span> : monto;
    const cuando = [f.fecha, f.nota].filter(Boolean).join(' · ');
    const marco = `rounded-2xl bg-card border ${seleccionado ? 'border-brand-red' : 'border-black/10 dark:border-white/[0.08]'}`;

    return (
        <>
            {/* ── Celular ──
                16-oct-2026: el nombre arriba (es lo que se busca con la vista), después la etapa y
                el cuándo, y abajo quién y qué. El botón solo cuando es un paso real (Asignar, Cobrar…):
                "Ver" es lo mismo que tocar la tarjeta, y le comía el ancho a la última línea. */}
            <div className={`fila-cel md:hidden ${marco} px-3.5 py-3`} style={{ borderLeftWidth: 5, borderLeftColor: borde }}>
                <div className="flex items-start gap-2">
                    {casilla}
                    <button type="button" onClick={seleccionando ? onToggle : onAbrir} disabled={!f.servicio && !f.orden && !f.servicios?.length && !seleccionando}
                        className="flex-1 min-w-0 text-left disabled:cursor-default space-y-1">
                        <span className="flex items-baseline justify-between gap-2">
                            <span className="font-black text-body-lg leading-tight text-ink truncate">{f.cliente}</span>
                            <span className="text-body text-ink shrink-0">{montoCel}</span>
                        </span>
                        <span className="flex items-center gap-1.5 text-caption min-w-0">
                            {etiqueta}
                            {f.esVenta && <span className="px-1 rounded bg-chip text-muted">Venta</span>}
                            {cuando && <span className={`font-bold truncate ${f.alerta ? 'text-[color:var(--alerta-tx)]' : 'text-secondary'}`}>{f.alerta ? '⚠ ' : ''}{cuando}</span>}
                        </span>
                        <span className="flex items-center gap-1.5 text-caption text-muted min-w-0">
                            <AvatarTecnico nombre={f.tecnicoTexto ? null : f.tecnico} size={18} />
                            <span className="truncate">{tecTxt}{f.detalle ? ` · ${f.detalle}` : ''}</span>
                        </span>
                    </button>
                    <div className="shrink-0 flex flex-col items-end gap-2 -mr-1">
                        <button type="button" onClick={onMenu} aria-label="Más acciones"
                            className="w-8 h-8 rounded-lg flex items-center justify-center text-muted active:bg-chip">
                            <LuEllipsisVertical size={17} />
                        </button>
                    </div>
                </div>
                {accionCel && <div className="flex justify-end mt-2">{accionCel}</div>}
            </div>

            {/* ── Escritorio ── */}
            <div className={`fila-pc hidden md:grid ${marco} px-4 py-3 ${GRID} ${GRID_GAP} items-center`}
                style={{ borderLeftWidth: 5, borderLeftColor: borde }}>
                <span className="flex items-center gap-2 text-label font-black uppercase tracking-wide">
                    {casilla}
                    {etiqueta}
                    {f.esVenta && <span className="ml-1 px-1.5 py-0.5 rounded bg-chip text-muted normal-case tracking-normal">Venta</span>}
                </span>
                <button type="button" onClick={seleccionando ? onToggle : onAbrir} disabled={!f.servicio && !f.orden && !f.servicios?.length && !seleccionando}
                    className="min-w-0 text-left disabled:cursor-default">
                    <span className="block font-bold text-body text-ink truncate">{f.cliente}</span>
                    <span className="block text-caption text-muted truncate">{f.detalle || '—'}</span>
                    <span className="2xl:hidden flex items-center gap-1.5 mt-0.5 text-caption text-secondary min-w-0">
                        <AvatarTecnico nombre={f.tecnicoTexto ? null : f.tecnico} size={16} /><span className="truncate">{tecTxt}</span>
                    </span>
                </button>
                <span className="hidden 2xl:flex items-center gap-2 text-caption text-secondary">
                    <AvatarTecnico nombre={f.tecnicoTexto ? null : f.tecnico} size={22} />{tecTxt}
                </span>
                <span className="flex flex-col gap-0.5 text-caption">
                    <span className="text-ink">{f.fecha || '—'}</span>
                    {f.nota && <span className={f.alerta ? 'font-bold text-[#B45309] dark:text-[#FBBF24]' : 'text-muted'}>{f.nota}</span>}
                </span>
                <span className="text-right font-black text-body text-ink">{monto}</span>
                <div className="flex justify-end">{accion}</div>
                <button type="button" onClick={onMenu} aria-label="Más acciones"
                    className="w-9 h-9 rounded-xl flex items-center justify-center text-muted hover:bg-chip">
                    <LuEllipsisVertical size={18} />
                </button>
            </div>
        </>
    );
}
